import React, { Component } from "react";
import PropTypes from "prop-types";
import i18next from "i18next";
import GridView from "../GridView/GridView";
import PopupWrapper from "../PopupWrapper";

class SubgridPanel extends Component {
  constructor(props, context) {
    super(props, context);
  }

  closePanel = () => {
    if (this.props.onClose)
      this.props.onClose();
  }

  renderButtons = () => {
    if (this.props.renderButtons)
      return this.props.renderButtons(this.props.dataItem, this.props.onClose);
    return null;
  }
  render() {
    return (
        <PopupWrapper onClose={this.closePanel} popupVisible={true} title={this.props.title} maxWidthBody={this.props.maxWidthBody} renderButtons={this.renderButtons}>
          <GridView dataItem={this.props.dataItem} readOnly={this.props.readOnly} renderRowEx={this.props.renderRowEx}
                    showHeader={this.props.showHeader} showEditColumn={this.props.showEditColumn} headerCellStyleProvider={this.props.headerCellStyleProvider}
          />
        </PopupWrapper>
    )
  }
}

SubgridPanel.propTypes = {
  dataItem: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  title: PropTypes.string,
  renderRowEx: PropTypes.func,
  showHeader: PropTypes.bool,
  maxWidthBody: PropTypes.string,
  showEditColumn: PropTypes.bool,
  headerCellStyleProvider: PropTypes.func,
  renderButtons: PropTypes.func,
};


SubgridPanel.defaultProps = {
  readOnly : false,
  title: i18next.t("Subgrid"),
  showSubgridHeader: true,
  showEditColumn: false
};

export default SubgridPanel;